import { ISafetyHubData } from 'types/safetyHub.interface'
import { USE_OPS_MOCKS } from '../Shared/opsControl'

const DEMO_SAFETY_HUB: ISafetyHubData = {
  zones: { operational: 12, held: 1, evacuated: 0 },
  permits: { draft: 2, issued: 4, active: 9, suspended: 1, closed: 14, expired: 3 },
  incidents: { l1Minor: 3, l2Moderate: 1, l3Serious: 1, l4Fatal: 0 },
  fatigue: { low: 38, elevated: 5, high: 2, critical: 0 },
}

const EMPTY_SAFETY_HUB: ISafetyHubData = {
  zones: { operational: 0, held: 0, evacuated: 0 },
  permits: { draft: 0, issued: 0, active: 0, suspended: 0, closed: 0, expired: 0 },
  incidents: { l1Minor: 0, l2Moderate: 0, l3Serious: 0, l4Fatal: 0 },
  fatigue: { low: 0, elevated: 0, high: 0, critical: 0 },
}

export const SAFETY_HUB_DATA: ISafetyHubData = USE_OPS_MOCKS ? DEMO_SAFETY_HUB : EMPTY_SAFETY_HUB
